import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ICONOS_ESTADO } from '@/config/iconografia';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary] Error capturado:', error, info.componentStack);
  }

  override render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: 32,
            gap: 16,
            textAlign: 'center',
          }}
        >
          <ICONOS_ESTADO.advertencia size={40} strokeWidth={2} color="#F7A400" aria-hidden="true" />
          <div style={{ fontSize: 17, fontWeight: 700, color: 'var(--navy)' }}>
            Algo salió mal
          </div>
          <div style={{ fontSize: 13, color: 'var(--ink-500)', maxWidth: 280 }}>
            {this.state.error?.message ?? 'Error inesperado en la aplicación.'}
          </div>
          <button
            type="button"
            className="primary-btn"
            style={{ marginTop: 8, width: 'auto', padding: '12px 28px' }}
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
          >
            Reintentar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
